import React, { Component } from 'react';
import { Pagination, Row, Button, Spin } from 'antd';
import { app, api, config } from "../../../app";

class TeamMien extends Component {
    constructor (props) {
        super(props);
        this.state = {
            dataList: [],
            data_loading: true,
            page: 1,
            total: 0,
            teamno: props.match.params.teamno,
            teamname: "正在加载 ... "
        };
    }

    async componentDidMount () {
        this._isMounted = true;
        await this.handleData();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    setData = (data) => app.setStateSync(this, data);

    /**
     * 数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleData = async (page = 1) => {
        await this.setData({ page, data_loading: true });
        let { teamno } = this.state,
            params = {
                page,
                teamno,
                request: "team",
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total, teamname } = await app.post(api.TeamStyleList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        if (page === this.state.page) {
            this.setData({ teamname, data_loading: false, dataList: data, total: parseInt(total || 0) });
        }
    };

    handleToDetail = (id) => {
        this.props.history.push('/ranks/mien/detail/' + id);
    }

    render () {
        let { data_loading, teamname, dataList, total, page } = this.state;
        return (
            <div className="mien-page">
                <Row className="mien-title" type="flex" justify="space-between">
                    <span>队伍风采（{teamname}）</span>
                    <Button type="primary" onClick={() => this.props.history.go(-1)}>返回</Button>
                </Row>
                <div className="mp-content">
                    <Row className="no-data" type="flex" justify="center" align="middle" hidden={!data_loading}><Spin/></Row>
                    <div className="mp-list" hidden={data_loading}>
                        {
                            dataList.map((item, i) => {
                                return (
                                    <div className="dl-img-item" key={i} onClick={() => this.handleToDetail(item.id)}>
                                        <div className="dii-img"><img src={config.imgUrl + item.style_img}/></div>
                                        <div className="dii-name">{item.style_title}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <Pagination
                        total={total}
                        current={page}
                        pageSize={20}
                        size="small"
                        showTotal={(total) => `总数量：${total}`}
                        onChange={this.handleData}
                        style={{ textAlign: "center", padding: 20 }}
                    />
                </div>
            </div>
        );
    }
}

export default TeamMien;



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamMore/TeamMien.jsx